var $b37ee03672edfd1d$exports = {};
$b37ee03672edfd1d$exports = {
  "ascending": "did\u0117jan\u010Dia tvarka",
  "ascendingSort": function ascendingSort(args) {
    return "surikiuota pagal stulpel\u012F ".concat(args.columnName, " did\u0117jan\u010Dia tvarka");
  },
  "columnSize": function columnSize(args) {
    return "".concat(args.value, " piks.");
  },
  "descending": "ma\u017E\u0117jan\u010Dia tvarka",
  "descendingSort": function descendingSort(args) {
    return "surikiuota pagal stulpel\u012F ".concat(args.columnName, " ma\u017E\u0117jan\u010Dia tvarka");
  },
  "resizerDescription": "Paspauskite \u201EEnter\u201C, kad prad\u0117tum\u0117te keisti dyd\u012F",
  "select": "Pasirinkti",
  "selectAll": "Pasirinkti visk\u0105",
  "sortable": "rikiuojamas stulpelis"
};
export { $b37ee03672edfd1d$exports as default };